import * as React from 'react';
import { Upload } from 'lucide-react';
import { cn } from '@/lib/utils';

export function ImageDropZone({
  dragging,
  htmlFor,
  onDragOver,
  onDragLeave,
  onDrop,
  hint = 'PNG, JPG, WEBP · Max 20MB each · Multiple allowed',
  children,
  variant = 'default',
}: {
  dragging: boolean;
  htmlFor: string;
  onDragOver: React.DragEventHandler;
  onDragLeave: React.DragEventHandler;
  onDrop: React.DragEventHandler;
  hint?: string;
  children?: React.ReactNode;
  variant?: 'default' | 'button';
}) {
  const isButton = variant === 'button';

  return (
    <label
      htmlFor={htmlFor}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      className={cn(
        'block border-dashed text-center cursor-pointer transition-all duration-200',
        'peer-focus-visible:ring-2 peer-focus-visible:ring-emerald-500 peer-focus-visible:ring-offset-2',
        isButton ? 'rounded-xl border px-4 py-6' : 'rounded-xl border-2 p-8',
        dragging
          ? 'border-emerald-400 bg-emerald-50 scale-[1.01]'
          : isButton
            ? 'border-[#D0D5DD] hover:border-emerald-300 hover:bg-slate-50'
            : 'border-slate-200 hover:border-emerald-300 hover:bg-slate-50',
      )}
    >
      {isButton ? (
        <>
          <span className="inline-flex items-center gap-2 rounded-lg border border-[#E4E7EC] bg-white px-3.5 py-2 text-sm font-medium text-[#101828] shadow-[0_1px_2px_rgba(16,24,40,0.06)]">
            <Upload className="h-4 w-4 text-[#344054]" />
            Upload
          </span>
          <p className="mt-3 text-sm font-medium text-[#344054]">
            Choose images or drag & drop it here.
          </p>
        </>
      ) : (
        <>
          <div className="w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center mx-auto mb-3">
            <Upload className="h-5 w-5 text-slate-400" />
          </div>
          <p className="text-sm font-medium text-slate-700">
            Drop images here or click to browse
          </p>
        </>
      )}
      <p className={cn('text-xs mt-1', isButton ? 'text-[#667085]' : 'text-slate-400')}>
        {hint}
      </p>
      {children}
    </label>
  );
}
